<nz-layout>
    <nz-content class="table-container">
        <div class="table-wrapper" (scroll)="onScroll($event)" (scrollend)="onScrollEnd($event)" #scroll>
            <table-pro [config]="config!" [currentPage]="1" [currentPageSize]="1000" [tableData]="[]" [stickyTop]="40"
                (queryPanelStateChange)="queryPanelStateChange($event)" (resetClick)="resetSearch()"
                (searchClick)="searchClick($event)">

                <div class="grid overview" overview>
                    <div class="row">
                        <div class="column no-border" [style.width]="'150px'">
                            <nz-cascader class="color-primary" (ngModelChange)="onSectionChange()"
                                [nzOptions]="cascaderOptions" [(ngModel)]="cascaderValue" [nzShowSearch]="true"
                                [nzPlaceHolder]="'选择标段'" [nzAllowClear]="false">
                            </nz-cascader>
                        </div>
                        <div class="column no-border" [style.width]="'10rem'">
                            <b>外观检测</b>
                        </div>
                        <div class="column no-border" [style.width]="'10rem'">
                            最终检查总计扣分：
                        </div>
                        <div class="column no-border color-danger" [style.width]="'4rem'">
                            <b>{{totalSum}}</b>
                        </div>
                        <div class="column no-border" [style.width]="'8rem'">
                            外观检查报告：
                        </div>
                        <div class="column no-border clickable color-primary" [style.width]="'8rem'"
                            *ngFor="let report of reportList; let index = index" (click)="view(index)">
                            {{report.fileSn}}
                        </div>
                        <div class="column no-border" [style.width]="'4rem'">
                            <button nz-button nzType="primary" (click)="addReport()" [disabled]="!canWrite">+报告
                            </button>
                        </div>
                    </div>

                </div>

                <div body>
                    <table [style.left]="0" [style.width]="totalWidth + 'px'">
                        <colgroup>
                            <col span="1" [style.width]="(56 * 100 / totalWidth) + '%'">
                            <col span="1" *ngFor="let item of config?.columns ?? []"
                                [style.width]="(item.width * 100 / totalWidth) + '%'">
                        </colgroup>
                        <tr *ngFor="let item of recordTable ?? []; let index = index;"
                            class="{{index < recordTable.length - 1 && !!recordTable[index + 1].dwTypeName ? 'border-bottom-black' : ''}}">
                            <td [style.textAlign]="'center'">{{index + (pager.pageIndex - 1) * pager.pageSize + 1}}</td>
                            <td class="border-bottom-black background-white border-right-black" *ngIf="item.dwTypeName"
                                [rowSpan]="item.dwTypeSpan ?? 1" [style.textAlign]="'center'">
                                <b>{{item.dwTypeName}}</b>
                            </td>
                            <td class="border-bottom-black background-white" *ngIf="item.dwCode"
                                [rowSpan]="item.dwCodeSpan ?? 1">
                                <b>{{item.dwCode}} {{item.dwName}}</b>
                            </td>
                            <td [style.textAlign]="'center'" class="border-bottom-black background-white editable"
                                *ngIf="item.dwCode" [rowSpan]="item.dwCodeSpan ?? 1">
                                <p>{{item.dwMileage}}</p>
                                <div class="text-container">
                                    <textarea [(ngModel)]="item.dwMileage"
                                        (blur)="onBlur(item.id!, 'dwMileage' , item.dwMileage ?? '')"
                                        (click)="edit('dwMileage' + item.id)"
                                        class="{{editing['dwMileage' + item.id] ? '' : 'transparent'}}"></textarea>
                                </div>
                            </td>
                            <td [style.textAlign]="'center'" class="border-bottom-black background-white color-danger"
                                *ngIf="item.dwCode" [rowSpan]="item.dwCodeSpan ?? 1">
                                <b>{{totalSumMap[item.dwType! + item.dwCode!] ?? 0}}</b>
                            </td>
                            <td rowSpan="1">
                                {{item.jgFbName}}
                            </td>
                            <td [style.textAlign]="'center'" rowSpan="1" class="color-primary editable">
                                <format-data [contentStr]="item.initScore?.toString() ?? ''">
                                    <input type="text" [(ngModel)]="item.initScore" appDigitalFormat="negativeInteger"
                                        (blur)="onBlur(item.id!, 'initScore' , item.initScore?.toString() ?? '0')"
                                        (click)="edit('initScore' + item.id)"
                                        class="{{editing['initScore' + item.id] ? '' : 'transparent'}}">
                                </format-data>
                            </td>
                            <td [style.textAlign]="'center'" rowSpan="1" class="color-danger">
                                <format-data [contentStr]="item.finalScore?.toString() ?? ''">
                                    <input type="text" [(ngModel)]="item.finalScore" appDigitalFormat="negativeInteger"
                                        (blur)="onBlur(item.id!, 'finalScore' , item.finalScore?.toString() ?? '0')"
                                        (click)="edit('finalScore' + item.id)"
                                        class="{{editing['finalScore' + item.id] ? '' : 'transparent'}}">
                                </format-data>
                            </td>
                            <td rowSpan="1" class="color-primary editable">
                                <format-data [contentStr]="item.comment?.toString() ?? ''" [patternStr]="'E+600'">
                                    <input type="text" [(ngModel)]="item.comment"
                                        (blur)="onBlur(item.id!, 'comment' , item.comment ?? '')"
                                        (click)="edit('comment' + item.id)"
                                        class="{{editing['comment' + item.id] ? '' : 'transparent'}}">
                                </format-data>
                            </td>
                        </tr>
                    </table>

                    <!-- 骨架行 -->
                    <table class="fake {{scrollIndex % 2 === 1 ? 'odd' : ''}}" *ngIf="recordFakeTable.length > 0"
                        [style.left]="0" [style.width]="totalWidth + 'px'"
                        [style.top]="(scrollTop + (isOpen ? 136 : 72)) + 'px'">
                        <colgroup>
                            <col span="1" [style.width]="(56 * 100 / totalWidth) + '%'">
                            <col span="1" *ngFor="let col of config?.columns ?? []"
                                [style.width]="(col.width * 100 / totalWidth) + '%'">
                        </colgroup>
                        <tr class="{{index < recordFakeTable.length - 1 && !!recordFakeTable[index + 1].dwTypeName ? 'border-bottom-black' : ''}}"
                            *ngFor="let item of recordFakeTable; let index = index;">
                            <td [style.textAlign]="'center'">{{index + (pager.pageIndex - 1) * pager.pageSize +
                                scrollIndex + 1}}</td>
                            <td class="border-bottom-black background-white border-right-black" *ngIf="item.dwTypeName"
                                [rowSpan]="item.dwTypeSpan ?? 1" [style.textAlign]="'center'">
                                <b>{{item.dwTypeName}}</b>
                            </td>
                            <td class="border-bottom-black background-white" *ngIf="item.dwCode"
                                [rowSpan]="item.dwCodeSpan ?? 1">
                                <b>{{item.dwCode}} {{item.dwName}}</b>
                            </td>
                            <td [style.textAlign]="'center'" class="border-bottom-black background-white editable"
                                *ngIf="item.dwCode" [rowSpan]="item.dwCodeSpan ?? 1">
                                <p>{{item.dwMileage}}</p>
                                <div class="text-container">
                                    <textarea [(ngModel)]="item.dwMileage"
                                        (blur)="onBlur(item.id!, 'dwMileage' , item.dwMileage ?? '')"
                                        (click)="edit('dwMileage' + item.id)"
                                        class="{{editing['dwMileage' + item.id] ? '' : 'transparent'}}"></textarea>
                                </div>
                            </td>
                            <td [style.textAlign]="'center'" class="border-bottom-black background-white color-danger"
                                *ngIf="item.dwCode" [rowSpan]="item.dwCodeSpan ?? 1">
                                <b>{{totalSumMap[item.dwType! + item.dwCode!] ?? 0}}</b>
                            </td>
                            <td rowSpan="1">
                                {{item.jgFbName}}
                            </td>
                            <td [style.textAlign]="'center'" rowSpan="1" class="color-primary editable">
                                <format-data [contentStr]="item.initScore?.toString() ?? ''">
                                    <input type="text" [(ngModel)]="item.initScore" appDigitalFormat="negativeInteger"
                                        (blur)="onBlur(item.id!, 'initScore' , item.initScore?.toString() ?? '0')"
                                        (click)="edit('initScore' + item.id)"
                                        class="{{editing['initScore' + item.id] ? '' : 'transparent'}}">
                                </format-data>
                            </td>
                            <td [style.textAlign]="'center'" rowSpan="1" class="color-danger editable">
                                <format-data [contentStr]="item.finalScore?.toString() ?? ''">
                                    <input type="text" [(ngModel)]="item.finalScore" appDigitalFormat="negativeInteger"
                                        (blur)="onBlur(item.id!, 'finalScore' , item.finalScore?.toString() ?? '0')"
                                        (click)="edit('finalScore' + item.id)"
                                        class="{{editing['finalScore' + item.id] ? '' : 'transparent'}}">
                                </format-data>
                            </td>
                            <td rowSpan="1" class="color-primary editable">
                                <format-data [contentStr]="item.comment?.toString() ?? ''" [patternStr]="'E+600'">
                                    <input type="text" [(ngModel)]="item.comment"
                                        (blur)="onBlur(item.id!, 'comment' , item.comment ?? '')"
                                        (click)="edit('comment' + item.id)"
                                        class="{{editing['comment' + item.id] ? '' : 'transparent'}}">
                                </format-data>
                            </td>
                        </tr>
                    </table>
                </div>
            </table-pro>
        </div>
    </nz-content>

</nz-layout>